import React from 'react';
import styles from './styles.scss';
import { Col, Container, Row } from '../../components/Grid';

const FormSuccessMessage = () => (
  <Container>
    <Row className={styles.marginS}>
      <Col>
        <p>
          VIELEN DANK
          <br />
          Ihre Anfrage wurde erfolgreich versandt. Wir melden uns in Kürze bei Ihnen, um einen
          Termin zu vereinbaren.
        </p>
        <p>
          Mit freundlichen Grüßen,
          <br />
          Ihr Autohaus Team
        </p>
      </Col>
    </Row>
  </Container>
);

export default FormSuccessMessage;
